// extracted by mini-css-extract-plugin
export default {"thead":"DescriptionsTableB_thead__3Ns9W","descriptionCell":"DescriptionsTableB_descriptionCell__xr2yp","tableCell":"DescriptionsTableB_tableCell__-Vqg+"};